__turbopack_context__.v({
  "button": "Radio-module-sass-module__Q2mDwq__button",
  "error": "Radio-module-sass-module__Q2mDwq__error",
  "radio-indicator": "Radio-module-sass-module__Q2mDwq__radio-indicator",
  "radio-label": "Radio-module-sass-module__Q2mDwq__radio-label",
});
